import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  urlLink:''

}
const mutations = {
  SET_URL(state, url){
    state.urlLink = url;
  }
}
const actions = {

}
const store = new Vuex.Store({
  state,
  mutations,
  actions,
})

export default store